export function sanitizeInput(value: string): string {
  return value
    .trim()
    .replace(/\s+/g, ' ')
    .replace(/^[,;\s]+|[,;\s]+$/g, '');
}

export function includesValue(
  values: string[],
  value: string,
  disableCaseSensitivity = false
): boolean {
  if (!disableCaseSensitivity) {
    return values.includes(value);
  }
  const key = value.toLowerCase();
  return values.some((v) => v.toLowerCase() === key);
}

export function splitPastedValues(
  pasted: string,
  disableCaseSensitivity = false
): string[] {
  const seen = new Set<string>();
  return pasted
    .split(/[;,]+/)
    .map(sanitizeInput)
    .filter((v) => {
      if (v.length === 0) {
        return false;
      }
      const key = disableCaseSensitivity ? v.toLowerCase() : v;
      if (seen.has(key)) {
        return false;
      }
      seen.add(key);
      return true;
    });
}
